<template>
  <div style="padding: 100px 0; position: relative; height: calc(100% - 281px)">
    <div class="boxBack" style="min-height: calc(100% - 100px)">
      <p>{{ msg }}</p>
      <div class="box" v-if="index == 1">
        <el-form
          class="demo-ruleForm"
          ref="backPass"
          :model="backPass"
          :rules="passrules"
          label-width="100px"
        >
          <el-form-item
            style="width: 500px"
            label="注册手机号"
            prop="telephone"
          >
            <el-input
              clearable
              v-model="backPass.telephone"
              type="text"
              auto-complete="off"
              placeholder="请输入注册手机号"
            >
            </el-input>
          </el-form-item>
          <el-form-item style="width: 500px">
            <el-button @click="getCode" type="success" :disabled="disabled"
              >获取验证码</el-button
            >
            <span v-show="is_pause == true" style="margin-left: 50px"
              >有效时间：{{ countdown }}s</span
            >
          </el-form-item>
          <el-form-item style="width: 500px" label="短信验证码" prop="msgCode">
            <el-input
              v-model="backPass.msgCode"
              type="text"
              auto-complete="off"
              clearable
              placeholder="请输入短信验证码"
            >
            </el-input>
          </el-form-item>
          <el-form-item style="width: 400px; margin-top: 30px">
            <el-button type="primary" @click="submitPas('backPass')"
              >确认</el-button
            >
            <el-button @click="goSignin('backPass')">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="box" v-if="index == 2">
        <el-form
          :model="dynamicValidateForm"
          ref="dynamicValidateForm"
          label-width="200px"
          class="demo-dynamic"
        >
          <el-form
            class="demo-ruleForm"
            ref="passform"
            :model="passform"
            :rules="passrules"
            label-width="100px"
          >
            <el-form-item
              style="width: 500px"
              v-if="visible"
              label="新密码"
              prop="passwd"
            >
              <el-input
                v-model="passform.passwd"
                type="text"
                auto-complete="off"
                placeholder="请输入新密码"
                @keyup.enter.native="handleLogin"
              >
              </el-input>
              <img
                src="../image/iframe/looky.png"
                @click="showPass('show')"
                class="icon-yincan scrimg"
              />
            </el-form-item>

            <el-form-item
              class="looky"
              style="width: 500px"
              v-else
              label="新密码"
              prop="passwd"
            >
              <el-input
                v-model="passform.passwd"
                type="password"
                auto-complete="off"
                placeholder="请输入新密码"
                @keyup.enter.native="handleLogin"
              >
              </el-input>
              <img
                src="../image/iframe/lookn.png"
                @click="showPass('show')"
                class="icon-xianshi scrimg"
              />
            </el-form-item>

            <!-- <el-form-item
              label="密码强度"
              style="margin-top: 40px; margin-bottom: 30px"
            >
              <div class="input_span">
                <div class="one" id="one"></div>
                <div class="two" id="two"></div>
                <div class="three" id="three"></div>
              </div>
              <div id="font">
                <span>弱</span>
                <span>中</span>
                <span>强</span>
              </div>
            </el-form-item> -->
            <el-form-item v-if="visiblea" label="确认密码" prop="passwords">
              <el-input
                style="height: 45px"
                placeholder="请输入确认密码"
                v-model="passform.passwords"
                type="text"
                auto-complete="off"
                @keyup.enter.native="handleLogin"
              >
              </el-input>
              <img
                src="../image/iframe/looky.png"
                @click="showPassa('show')"
                class="icon-yincan scrimg"
              />
            </el-form-item>

            <el-form-item
              class="looky"
              v-else
              label="确认密码"
              prop="passwords"
            >
              <el-input
                style="height: 45px"
                placeholder="请输入确认密码"
                v-model="passform.passwords"
                type="password"
                auto-complete="off"
                @keyup.enter.native="handleLogin"
              >
              </el-input>
              <img
                src="../image/iframe/lookn.png"
                @click="showPassa('show')"
                class="icon-xianshi scrimg"
              />
            </el-form-item>
            <el-form-item style="width: 400px">
              <el-button
                type="primary"
                @click="submitForm('passform')"
                >确认</el-button
              >
              <el-button @click="goback">返回</el-button>
            </el-form-item>
          </el-form>
        </el-form>
      </div>
    </div>
    <Foot class="foot" />
  </div>
</template>

<script>
import { resetPassword } from "@/api/api.js";
import { checkIsRegist, sendSmsCaptcha, checkCaptcha } from "../api/api";
import Foot from "../components/Foot.vue";
export default {
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value !== this.passform.passwords) {
        callback(new Error("请确认新密码"));
      } else {
        callback();
      }
    };

    const checkPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("新密码不能为空"));
      } else {
        let reg = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@$!%*?&#:;,.-/~<>|{}+_()="^\\[\]`-])[a-zA-Z\d@$!%*?&#:;,.-/~<>|{}+_()="^\\[\]`-]{8,16}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(
            new Error("请输入8-16位同时包含数字、字母大小写及特殊字符#@!~%^&*_$的组合")
          );
        }
      }
    };
    // 短信验证码
    const codeMsg = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("验证码不能为空"));
      } else {
        let reg = /^[0-9]{6}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入六位数字验证码"));
        }
      }
    };
    let checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      } else if (!this.isCellPhone(value)) {
        // 引入methods中封装的检查手机格式的方法
        return callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    return {
      msg: "密码找回",
      visiblea: false,
      visible: false,
      index: "1",
      msgText: "",
      passform: {
        passwd: "",
        id: "",
        passwords: "",
      },
      backPass: {
        telephone: "",
        msgCode: "",
      },
      dynamicValidateForm: {
        domains: [
          {
            value: "",
          },
        ],
        email: "",
      },

      passrules: {
        passwords: [
          {
            required: true,
            message: "确认密码不能为空",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请再次输入新密码"));
              } else if (value !== this.passform.passwd) {
                callback(new Error("两次输入密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],

        passwd: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          {
            min: 8,
            max: 16,
            message: "8-16位同时包含数字、字母大小写及特殊字符的组合",
            trigger: "blur",
          },
          { validator: checkPass, trigger: ["blur", "change"] },
        ],

        newpassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 4,
            max: 20,
            trigger: ["blur", "change"],
            message: "密码长度为4到20位",
          },
        ],
        telephone: [
          {
            required: true,
            message: "注册手机号不能为空",
            trigger: "blur",
          },
          { validator: checkMobile, trigger: ["change", "blur"] },
        ],
        msgCode: [
          {
            required: true,
            message: "短信验证码不能为空",
            trigger: "blur",
          },
          {
            validator: codeMsg,
            trigger: "blur",
          },
        ],
      },
      countdown: 0, //倒计时
      countdownNum: 0,
      timer: null, //定时器
      is_pause: false, //是否暂停
      disabled: true,
      uuid: "",
    };
  },
  components: {
    Foot,
  },
  watch: {
    "backPass.telephone": {
      handler(newname, oldname) {
        if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(newname)) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      },
     
    },
    "backPass.msgCode"(val) {
        if (val > 999999) {
          this.backPass.msgCode = val.slice(0, 6);
        }
    },
    countdown(val) {
      if (val == 0) {
        clearInterval(this.timer);
        // 倒计时结束后需要执行的操作
        this.is_pause = false;
        this.disabled = false;
      }
    },
    // //"passform.passwd": {
    //   handler(newname, oldname) {
    //     this.msgText = this.checkStrong(newname);
    //     if (this.msgText > 1 || this.msgText == 1) {
    //       document.getElementById("one").style.background = "red";
    //     } else {
    //       document.getElementById("one").style.background = "#eee";
    //     }
    //     if (this.msgText > 2 || this.msgText == 2) {
    //       document.getElementById("two").style.background = "orange";
    //     } else {
    //       document.getElementById("two").style.background = "#eee";
    //     }
    //     if (this.msgText == 4) {
    //       document.getElementById("three").style.background = "#00D1B2";
    //     } else {
    //       document.getElementById("three").style.background = "#eee";
    //     }
    //   },
    // },//
  },

  created() {
    // this.angePassword();
  },

  methods: {
    //验证手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    timeFn() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
          // 倒计时结束后需要执行的操作
          this.is_pause = false;
          this.disabled = false;
        }
      }, 1000);
    },
    // 获取验证码
    getCode() {
      if (this.backPass.telephone == "") {
        this.$message.warning("请输入手机号");
        return false;
      }
      checkIsRegist(this.$qs.stringify({ code: this.backPass.telephone })).then(
        (res) => {
          if (res.code == 1000) {
            if (res.data == true) {
              sendSmsCaptcha(
                this.$qs.stringify({ code: this.backPass.telephone,exist:true })
              ).then((res) => {
                if (res.code == 1000) {
                  this.$message.success("发送成功请留意短信");
                  this.countdown = "120";
                  this.is_pause = true;
                  this.disabled = true;
                  this.timeFn();
                } else {
                  this.is_pause = false;
                  this.disabled = false;
                  this.$message.error(res.msg);
                }
              });
            } else {
              this.$message.warning("该手机号未注册");
              return false;
            }
          } else {
            this.$message.error(res.msg);
            return false;
          }
        }
      );
    },
    // 密码找回返回登录页面
    goSignin() {
      this.$router.push({
        name: "Signin",
      });
    },
    // 密码找回确定
    submitPas(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.countdown == 0) {
            this.$message.warning("请重新获取验证码");
            return false;
          }
          let form = {
            captcha: this.backPass.msgCode,
            phoneNumber: this.backPass.telephone,
          };
          checkCaptcha(this.$qs.stringify(form)).then((res) => {
            if (res.code == 1000) {
              this.uuid = res.data;
              this.index = "2";
              this.msg = "修改密码";
            } else {
              this.$message.error(res.msg);
              return false;
            }
          });
        }
      });
    },
    goback() {
      this.index = "1";
      this.msg = "密码找回";
      // this.passform = {};
    },
    angePassword() {
      if (sessionStorage.getItem("token") === null) {
        this.$router.push({
          name: "index",
        });
      }
    },
    showPassa(value) {
      this.visiblea = !this.visiblea;
    },
    showPass(value) {
      this.visible = !this.visible;
    },
    submitForm(passform) {
      var userJsonStr = sessionStorage.getItem("user");
      let userEntity = JSON.parse(userJsonStr);
      console.log(userEntity); // => tom

      this.$refs[passform].validate((valid) => {
        if (valid) {
          let encPass = this.$Base64.encode(this.passform.passwd);

          let encPasss = this.$Base64.encode(encPass);
          console.log(encPasss);

          console.log(valid);
          let obj = {
            uuid: this.uuid,
            newPassword: encPasss,
          };
          resetPassword(this.$qs.stringify(obj))
            .then((res) => {
              if (res.code == 1000) {
                this.$notify({
                  title: "成功",
                  message: "修改成功，返回到登录页面",
                  type: "success",
                });
                this.$router.push({ name: "Signin" });
                this.passform = { passwd: "", id: "" };
              } else {
                this.passform = { passwd: "", id: "" };
              }
            })
            .catch((err) => {
              //  router.push("/index")
              this.passform = {};
            });
        }
      });
    },
    checkStrong(sValue) {
      var modes = 0;
      //正则表达式验证符合要求的
      if (sValue.length < 1) return modes;
      if (/\d/.test(sValue)) modes++; //数字
      if (/[a-z]/.test(sValue)) modes++; //小写
      if (/[A-Z]/.test(sValue)) modes++; //大写
      if (/\W/.test(sValue)) modes++; //特殊字符

      //逻辑处理
      switch (modes) {
        case 1:
          return 1;

        case 2:
          return 2;

        case 3:
        case 4:
          return sValue.length < 4 ? 3 : 4;
      }
      return modes;
    },
  },
};
</script>


<style lang="less" scoped>
.passwprd {
  display: flex;
  width: 95%;
  align-items: center;
  height: 50px;
  border-bottom: 1px rgb(242, 242, 242) solid;
  margin: auto;
  p {
    padding: 0;
  }
}
.hello {
  background: #fff;
  height: 300px;
  width: 700px;
}
.one {
  height: 10px;
  width: 80px;
  // background: rgb(222, 89, 53);
}
.two {
  height: 10px;
  width: 80px;
  // background: rgb(243, 130, 28);
}
.three {
  height: 10px;
  width: 80px;
  // background: rgb(111, 157, 15);
}
.input_span {
  width: 200px;
  display: flex;
}
#font {
  width: 200px;
  display: flex;
  span {
    height: 20px;
    width: 80px;
  }
}
.box {
  width: 1200px;
  margin: auto;
  box-sizing: border-box;

  height: 400px;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  // padding-top: 40px;
}
.boxBack {
  width: 1200px;
  // background: #fff;
  // height: calc(100% - 80px);
  background: #fff;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  // justify-content: center;
  // align-items: center;
  box-shadow: 2px 2px 2px 2px #f0f0f0;
  margin: auto;
  p {
    padding-top: 30px;
    font-size: 18px;
    padding-left: 40px;
    font-weight: bold;
    // margin: 0 auto;
  }
}
.scrimg {
  position: absolute;
  right: 20px;
  top: 10px;
}
.foot {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>